// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"BgVideoLines_bgVideoWrapper__hkTLs"};